import React from 'react';
import './HeadMenu.css';
import {AppstoreFilled, CalendarOutlined, MailOutlined, ExperimentOutlined} from '@ant-design/icons';
import {Menu, Typography} from 'antd';
import {useNavigate} from 'react-router-dom';
import appColors from '../../style/theme';
const {Text} = Typography;

const myItemsVis =
[{id: 0, label: 'Home', icon: AppstoreFilled, path: '/tecccm/home', chill: []},
  {id: 1, label: 'Team', icon: AppstoreFilled, path: '/tecccm/attributions',
    chill:
    [{id: 0, label: 'Team and Attributions', icon: AppstoreFilled, path: '/tecccm/attributions'},
      {id: 1, label: 'Collaborations', icon: AppstoreFilled, path: '/tecccm/collaborations'},
      {id: 2, label: 'Partnership', icon: AppstoreFilled, path: '/tecccm/partnership'}]},
  {id: 2, label: 'Project Description', icon: CalendarOutlined, path: '/tecccm/description',
    chill:
    [{id: 0, label: 'Description', icon: AppstoreFilled, path: '/tecccm/description'},
      {id: 1, label: 'Engineering Success', icon: AppstoreFilled, path: '/tecccm/engineering'},
      {id: 2, label: 'Contribution', icon: MailOutlined, path: '/tecccm/contribution'},
    ]},
  {id: 3, label: 'Lab', icon: ExperimentOutlined, path: '/tecccm/model',
    chill:
    [{id: 0, label: 'Project Modelling', icon: AppstoreFilled, path: '/tecccm/model'},
      {id: 1, label: 'Proof of Concept', icon: AppstoreFilled, path: '/tecccm/proof-of-concept'},
      {id: 2, label: 'Safety', icon: MailOutlined, path: '/tecccm/safety'},
    ]},
  {id: 4, label: 'Human Practices', icon: ExperimentOutlined, path: '/tecccm/human-practices',
    chill:
    [{id: 0, label: 'Integrated Human Practices', icon: AppstoreFilled, path: '/tecccm/human-practices'},
      {id: 1, label: 'Education', icon: MailOutlined, path: '/tecccm/education'},
      {id: 2, label: 'Communication', icon: MailOutlined, path: '/tecccm/communication'},
      {id: 3, label: 'Entrepreneurship', icon: ExperimentOutlined, path: '/tecccm/entrepreneurship'},
      {id: 4, label: 'Implementation', icon: AppstoreFilled, path: '/tecccm/implementation'},
    ]}];
const HeadMenu = () =>{
  const navigate = useNavigate();
  const items1 = myItemsVis.map((item) =>{
    return {
      key: item.path,
      label: <Text style={{color: 'white'}}>{item.label}</Text>,
      icon: React.createElement(item.icon),
      path: item.path,
      onTitleClick: () => navigate(item.path),
      children: item.chill.map((subItem) => {
        return {
          key: subItem.path,
          label: subItem.label,
          icon: React.createElement(subItem.icon),
          path: subItem.path,
        };
      }),
    };
  });
  return (
    <Menu
      className='MenuHead'
      mode="horizontal"
      style={{background: appColors['ColorBack']}}
      defaultOpenKeys={['1']}
      defaultSelectedKeys={['1']}
      items={items1}
      onClick={({keyPath}) => {
        navigate(keyPath[0]);
      }}
    />
  );
};
export default HeadMenu;
